import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';

import css from './ApprovalStatusBadge.module.css';

const ApprovalStatusBadge = props => {
  const { className, rootClassName, user, showDetails } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (!user) {
    return null;
  }

  const publicData = user.attributes?.profile?.publicData || {};
  const privateData = user.attributes?.profile?.privateData || {};
  const userType = publicData.userType;
  const categoryStatus = publicData.categoryStatus;
  const category = publicData.category;
  const pendingCategory = privateData.pendingCategory;
  const rejectionReason = privateData.categoryRejectionReason;

  // Only show badge for experts
  if (userType !== 'expert') {
    return null;
  }

  // Determine badge type and content
  let badgeType = null;
  let badgeText = null;
  let badgeDetails = null;

  if (categoryStatus === 'pending' && pendingCategory) {
    badgeType = 'pending';
    badgeText = 'Pending Approval';
    badgeDetails = showDetails ? `Requested: ${getCategoryLabel(pendingCategory)}` : null;
  } else if (categoryStatus === 'approved' && category) {
    badgeType = 'approved';
    badgeText = getCategoryLabel(category);
    badgeDetails = showDetails ? 'Verified Expert' : null;
  } else if (categoryStatus === 'rejected') {
    badgeType = 'rejected';
    badgeText = 'Application Under Review';
    badgeDetails = showDetails && rejectionReason ? `Feedback: ${rejectionReason}` : null;
  }

  if (!badgeType) {
    return null;
  }

  return (
    <div className={classes}>
      <span className={classNames(css.badge, css[`badge-${badgeType}`])}>
        {badgeType === 'approved' && <span className={css.icon}>✓</span>}
        {badgeType === 'pending' && <span className={css.icon}>⏳</span>}
        {badgeType === 'rejected' && <span className={css.icon}>!</span>}
        <span className={css.text}>{badgeText}</span>
      </span>
      {badgeDetails && (
        <span className={css.details}>{badgeDetails}</span>
      )}
    </div>
  );
};

// Helper function to get category label
const getCategoryLabel = (category) => {
  const categoryMap = {
    'written-story': 'Written Story Master',
    'motion-story': 'Motion Story Master',
    'visual-story': 'Visual Story Master',
    'business-story': 'Business Story Master',
    'publishing': 'Publishing Master',
    'education-coaching': 'Education & Coaching Master',
  };
  return categoryMap[category] || category;
};

ApprovalStatusBadge.defaultProps = {
  className: null,
  rootClassName: null,
  showDetails: false,
};

ApprovalStatusBadge.propTypes = {
  className: propTypes.string,
  rootClassName: propTypes.string,
  user: propTypes.user,
  showDetails: propTypes.bool,
};

export default ApprovalStatusBadge;